import React, { useEffect, useRef, useState } from 'react';
import useMediaSetup from './useMediaSetup';
import SignIn from '../signin';
import TaskPane from '../taskPane';
import TaskHeader from '../task-header';
import ErrorPage from "../errorPage";
import styles from './finimi.css';
import { i18n } from '../../utils/GadgetUtils';
import { useTaskListStore, TASKLIST_ACTIONS } from "../../Store";
import CallVariableLayout from '../CallVariables';
import Collapsible from '../Collapsible';
import "@momentum-ui/web-components/dist/comp/md-theme";
import { FINESSE_NON_VOICE_SIGNED_IN_KEY, saveToSessionStorage, getFromSessionStorage } from '../../utils/cacheUtils';

var conversationId = '';
const FinIMI = (props) => {
    const isMounted = useRef(true);
    const [recovered, setRecovered] = useState(false);
    const [isMediaRestoring, setMediaRestoring] = useState(false);

    const {
        state: {
            loading,
            signedIn,
            retry,
            error,
            conversationLoader,
            errorAfterTaskLoad
        },
        initialize,
        handleMediaLogin,
        setConversationLoader,
        setErrorAfterTaskLoad,
        wrapUpData,
        userData,
        scriptSelectorData,
        user,
        handleMediaOnFailback,
        cacheMediaStates,
        updateCacheBeforeDisconnect
    } = useMediaSetup({recovered, setMediaRestoring});
    const [taskListState, taskListHandleActions] = useTaskListStore();
    const [task, setTask] = useState(null);
    var prefs = new gadgets.Prefs();
    let useFinesseSimulator = prefs.getBool('use-finesse-imi-simulator');
    if (!useFinesseSimulator) {
        useFinesseSimulator = false;
    }

    const collapsibleShortcutKeyConfig = {
        shortcutKeyId: 'cisco_imi_interaction_exapndcollapse',
        shortcutKey: i18n.getMsg('gadget.imi.collapsible.interaction.action.key.8'),
        shortcutKeyAction: i18n.getMsg('gadget.imi.collapsible.interaction.action'),
        modifierKeys: window.finesse.shortcutkey.ShortcutKeyService.CONSTANTS.MODIFIER_KEYS.CTRL_ALT,
        componentName: i18n.getMsg('gadget.imi.collapsible.interaction.componentname')
    };

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [callVariableEditStatus, setCallVariableEditStatus] = useState('');
    const [callvariablesArray, setcallVariablesArray] = useState({});
    let siginInProgressTimerRef = null;
    
    /* On failback - once the desktop recovers try relogin if logged out and restore the agent state */
    const handleFailback = (data)=>{
        console.log('::- FinIMI handleFailback- ', data, data.status);

        if (data.status === "recovered" && getFromSessionStorage(FINESSE_NON_VOICE_SIGNED_IN_KEY)) {
            console.log('::- FinIMI handleFailback. recovery success. setting recovered state to true- ');
            handleMediaOnFailback(data);
            setRecovered(true);
        } else {
            updateCacheBeforeDisconnect();
        }
        if(siginInProgressTimerRef){ clearTimeout(siginInProgressTimerRef)}
  
        /* recovered state cleanup */
        siginInProgressTimerRef = setTimeout(() => {
            setRecovered(false);
            setMediaRestoring(false);
        }, 10000);
    }
  
    useEffect(() => {
        if (isMounted.current) {
            initialize();
            window.finesse.containerservices.ContainerServices.addHandler("finesse.info.connection", handleFailback); 
        }

        return () => {
            isMounted.current = false;
            window.finesse.containerservices.ContainerServices.removeHandler("finesse.info.connection", handleFailback); 
        }


    }, []);

    useEffect(() => {
        saveToSessionStorage(FINESSE_NON_VOICE_SIGNED_IN_KEY, signedIn);

        if (isMounted.current) {
        // Load simulator only if the media is signed in
            if (signedIn) {
               
            }
        }
    }, [signedIn]);

    useEffect(() => {
            if (taskListState.selectedTaskId) {
                let task = taskListState.taskList.find(task => task.taskId === taskListState.selectedTaskId);
                setTask(task);
                console.log(':: [taskListState] Load the new conversation ', task.conversationid, conversationId, task);
                if (task.conversationid && conversationId !== task.conversationid) {
                    window.imiEngageWC.setParam('data', {
                            "jwt": window.finesse.container.Config.authToken,
                            "lang": window.finesse.container.Config.locale.replace('_', '-'),
                            "conversationid": task.conversationid,
                            "source" : 'CCE'
                    });
                    conversationId = task.conversationid;
                    setConversationLoader(i18n.getMsg('gadget.imi.engage.loading'));
                }
                let taskActivityNotification = window.finesse.containerservices?.TaskActivityNotification?.init(window.finesse?.containerservices?.ContainerServices);
                let from = window.finesse.containerservices?.ContainerServices?.getMyGadgetId();
                let message = {
                    'timestamp' : new Date().getTime(), //optional
                    'taskId' : task.taskId,
                    'active' : true,
                    'mediaType' : task.mediaType
                }
                console.log(':: Notify other gadgets of active task ', from, message);
                taskActivityNotification && from && taskActivityNotification.notifyTaskSelection(from, message);
            } else {
                setTask(null);
            }
    }, [taskListState.selectedTaskId]);

    useEffect(() => {
        if (task) {
             // Temporary: until we have the actual IMI web component
            if (useFinesseSimulator) {
              window.loadImiSimulator({});
            } else {
                if (!task.areFieldsPresent) {
                    setErrorAfterTaskLoad({
                        title: i18n.getMsg('gadget.imi.gadgetLoad.task.error'),
                        description: i18n.getMsg('gadget.imi.gadgetLoad.task.errorDescription')
                    });
                }
            }
            task.updateTaskInLS && task.updateTaskInLS();
        }
    }, [task])


    useEffect(() => {
        if(task != null){
            if(task.callVarProps.callVariableEditStatus != callVariableEditStatus){
                setCallVariableEditStatus(task.callVarProps.callVariableEditStatus);
            }
            if(task.callVarProps.mediaProperties.callVariables != callvariablesArray){
                setcallVariablesArray(task.callVarProps.mediaProperties.callVariables);
            }
        }
        
    }, [{...task}])

    window.localStorage.setItem('unsavedChanges', unsavedChanges);
    

    useEffect(() => {
        console.log(":: [taskListState] is updated. Updated task list-  ", taskListState);
        if (taskListState.selectedTaskId) {
            setTask(taskListState.taskList.find(task => task.taskId === taskListState.selectedTaskId));
        }
        taskListState.taskList.forEach(pTask => {
            pTask.updateTaskInLS && pTask.updateTaskInLS();
        });
    }, [taskListState]);

    useEffect(() => {
        console.log('::- FinIMI useEffect[isMediaRestoring] - ', isMediaRestoring, signedIn);
}, [isMediaRestoring, signedIn]);

    return (
        <>
            {error ? <ErrorPage errorInfo={error}/>
            : retry ?
            <div className={styles.spinnerContainer}>
                <md-spinner size={36} />
                <div className={styles.spinnerText}>{i18n.getMsg('gadget.imi.operation.failed.signin')}</div>
                <div className={styles.spinnerText}>{i18n.getMsg('gadget.imi.operation.signinRetry')}</div>
            </div> :
            signedIn ? 
                <>
                {isMediaRestoring ? <div className={styles.spinnerContainer}>
                                        <md-spinner size={36} />
                                        <div className={styles.spinnerText}>{i18n.getMsg('gadget.imi.gadgetLoad.restoreMedia')}</div>
                                    </div>
                : <>
                    <TaskPane setConversationLoader={setConversationLoader} setErrorAfterTaskLoad={setErrorAfterTaskLoad} />
                    {task ?
                    <div className={styles.container}>
                        <TaskHeader task={task} userData={userData} wrapUpReasons={wrapUpData.wrapUpReasons} scriptSelectors={scriptSelectorData.scriptSelectors} unsavedChanges={unsavedChanges}></TaskHeader>
                            {/* Use the below actual IMI webcomponent once it is available */}
                            {/* <imi-engage></imi-engage> */}
                            {/* Mount the IMI Web Component Simulator here */}
                      <Collapsible containerCustomClass={styles.callvariablecontainer} shortcutKeyConfig={collapsibleShortcutKeyConfig}
                        customCollapsedClass={styles.collapsedcallvariable} buttonClass={styles.cvcollapsiblebutton}>
                            <CallVariableLayout {...task.callVarProps} unsavedChanges={unsavedChanges} setUnsavedChanges={setUnsavedChanges} 
                                callvariablesArray={callvariablesArray} /> 
                        </Collapsible>
                            {errorAfterTaskLoad && <ErrorPage errorInfo={errorAfterTaskLoad}/> }                       
                            {conversationLoader ? <div className={styles.spinnerContainer}>
                                <md-spinner size={36} />
                                <div className={styles.spinnerText} tabIndex="0" aria-label={conversationLoader}>{conversationLoader}</div>
                            </div>
                            :  useFinesseSimulator ? 
                            <div className={styles.simcontainer} id="imi-simulator"></div> 
                            : <div style={{height: '100%', overflow: 'auto'}}>
                                { task.mediaType !== 'email' ? 
                                 <md-theme lumos style={{width: '100%', height: 'calc(100vh - 114px)'}} >
                                    <imi-engage></imi-engage>
                                </md-theme> :
                                 <md-theme lumos style={{width: '100%', height: 'calc(100vh - 114px)'}} >
                                <imi-email-composer orgid={props.orgID} taskid={task.conversationid} agentid={window.finesse.container.Config.id} interactionid={""} agentname={window.finesse.container.Config.extension}></imi-email-composer></md-theme>
                                }
                            </div>}
                            </div> : <div id='empty-fin-imi-container' className={styles.emptyTaskContentArea}>{i18n.getMsg('gadget.imi.taskPane.title.noActiveTasks')}</div>}
                </>
                }
                </> 
                :loading ? <div className={styles.spinnerContainer}>
                            <md-spinner size={36} />
                            <div className={styles.spinnerText}>{i18n.getMsg('gadget.imi.gadgetLoad.signin')}</div>
                        </div> :<SignIn {...{handleMediaLogin, recovered}}>{i18n.getMsg('gadget.imi.operation.signin')}  </SignIn>}
        </>
    );
}
export default FinIMI;